const profilePic = (state) => state.profilePic;
const userName = (state) => state.userName;
const userEmail = (state) => state.userEmail;
const timezoneOffset = (state) => state.timezoneOffset;
const theme = (state) => state.theme;
const mobileTheme = (state) => state.mobileTheme;
const desktopTheme = (state) => state.desktopTheme;
const language = (state) => state.language;
const dataStorage = (state) => state.dataStorage;
// const googleScope = (state) => state.googleScope;
const userPreferences = (state) => state.userPreferences;
const downloadTopic = (state) => state.downloadTopic;
const systemTime = (state) => state.systemTime;

const soundId = (state) => state.soundId;
const userInfo = (state) => ({
  timezone_offset: state.timezoneOffset,
  theme: state.theme,
  language: state.language,
  user_preferences: state.userPreferences,
  sound_id: state.soundId, //,
  data_storage: state.dataStorage,
  // system_time: state.systemTime,
  // google_scope: state.googleScope
});
const maxConn = (state) => state.maxConn;

export default {
  profilePic,
  userName,
  userEmail,
  timezoneOffset,
  // googleScope,
  language,
  mobileTheme,
  desktopTheme,
  soundId,
  userPreferences,
  userInfo,
  theme,
  maxConn,
  dataStorage,
  downloadTopic,
  systemTime,
};
